import Axios from 'axios'
import { ENDPOINTS } from 'config'
import { signOut } from 'aws-amplify/auth'

export const axios = Axios.create({
  baseURL: ENDPOINTS.BASE_URL
})

axios.interceptors.response.use(
  (response) => {
    return response.data
  },
  async (error) => {
    const status = error?.response?.status
    const url = error?.config?.url ?? ''

    // Don't auto-logout on 401 from changePassword — it means wrong current password, not expired session
    const isPasswordChange = url.includes(ENDPOINTS.CHANGE_PASSWORD) || url.includes(ENDPOINTS.REQUEST_PASSWORD_CHANGE)

    if ((status === 401 || status === 403) && !isPasswordChange) {
      await signOut()
      window.location.href = '/signin'
    }

    return await Promise.reject(error)
  }
)
